<template>
    <div class="flex">
        <a href="#" title="Recent Notifications" class="text-base p-4 flex hover:text-yellow-300 text-white" @click.prevent="open()">
            <i class="fas fa-bell"></i>
        </a>
        <span v-if="unread > 0" class="absolute ml-6 items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-600 text-white">
          {{ unread }}
        </span>
        <slideover title="Notifications" name="notifications" shortcut="N">

            <div class="flex flex-row-reverse mb-6" v-if="unread">
                <ui-button-new @click.prevent="markRead()" primary small>Mark All Read</ui-button-new>
            </div>

            <div class="flow-root">
                <ul class="-mb-8">
                    <li v-for="notification in notifications" :class="{ 'opacity-50': notification.viewed }">
                        <div class="relative pb-8">
                            <!--                            <span class="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>-->
                            <div class="relative flex space-x-3">
                                <div class="mt-1">
                                    <i class="far fa-dot-circle text-lg"
                                       :class="{ 'text-brand': !notification.viewed, 'text-gray-500': notification.viewed }"></i>
                                </div>
                                <div class="min-w-0 flex-1 flex justify-between space-x-4">
                                    <div>
                                        <div class="text-sm text-gray-500 notification-widget-message-container"
                                           v-html="notification.message"></div>
                                    </div>
                                    <div class="text-right text-sm whitespace-nowrap text-gray-500">
                                        <time datetime="2020-09-20">{{ notification.created_at }}</time>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>

        </slideover>
    </div>
</template>

<script>
    import { Notification } from '@models'
    import UiButtonNew from "../ui/UiButtonNew";
    export default {
        components: {UiButtonNew},
        props: {},
        filters: {
            truncate: function (text, stop, clamp) {
                return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
            }
        },
        data() {
            return {
                show: false,
                unread: 0,
                notifications: [],
                disabledOpening: false,
                hidden: true,
            }
        },
        computed: {

        },
        methods: {
            async markRead(){
                await Notification.markAllRead();

                _.forEach(this.notifications, function(notification){
                    notification.viewed = true
                })

                this.calculateUnreadCount()
            },
            calculateUnreadCount: function () {
                this.unread = _.filter(this.notifications, function (notification) {
                    return !notification.viewed;
                }).length;

                eventBus.$emit('unread-notifications-calculated',this.unread);
            },
            async getNotifications(){
                this.notifications = await Notification.all();
                this.calculateUnreadCount();
            },
            close() {
                eventBus.$emit('slideover-close-notifications');
                this.hidden = true;
            },
            open() {
                window.Bus.emit('close-all-slideovers');
                eventBus.$emit('slideover-open-notifications');
                this.hidden = false;
            }
        },
        mounted() {
            var that = this;

            this.getNotifications();

            window.Bus.on('close-all-slideovers', () => {
                this.close()
            })

            window.Bus.on('show-package-filesystem', () => {
                this.close()
                this.disabledOpening = true;
            });

            window.Bus.on('close-package-filesystem', () => {
                this.disabledOpening = false;
            });

            eventBus.$on('new-notification', function () {
                that.getNotifications();
            });

            eventBus.$on('show-package-filesystem', function () {
                that.close()
                that.disabledOpening = true;
            });

            eventBus.$on('close-package-filesystem', function () {
                that.disabledOpening = false;
            });

            window.addEventListener('keydown', (e) => {
                if (e.ctrlKey || e.metaKey) {
                    return;
                }
                if (e.keyCode === 27) {
                    this.close()
                    return
                }
                if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(e.target.tagName)) {
                    return;
                }
                if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(document.activeElement.tagName)) {
                    return;
                }

                if (!this.disabledOpening) {
                    if ((e.key === 'n') || (e.key === 'N')) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (this.hidden) {
                            this.open()
                        } else {
                            this.close()
                        }
                    }
                }
            })
        }
    }
</script>

<style lang="css">
    .notification-widget-message-container a {
        color: #0088CE !important;
    }
</style>
